import api from './api';

const purchaseOrderService = {
  // Get all purchase orders
  getAllPurchaseOrders: async (params = {}) => {
    try {
      const queryParams = new URLSearchParams();
      if (params.page) queryParams.append('page', params.page);
      if (params.limit) queryParams.append('limit', params.limit);
      if (params.status) queryParams.append('status', params.status);
      if (params.supplier) queryParams.append('supplier', params.supplier);
      if (params.project) queryParams.append('project', params.project);
      if (params.search) queryParams.append('search', params.search);

      const queryString = queryParams.toString();
      const url = `/purchase-order${queryString ? `?${queryString}` : ''}`;
      
      const response = await api.get(url);
      return response.data;
    } catch (error) {
      console.error('Error fetching purchase orders:', error);
      throw error;
    }
  },

  // Get purchase order by ID
  getPurchaseOrderById: async (id) => {
    try {
      const response = await api.get(`/purchase-order/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching purchase order:', error);
      throw error;
    }
  },

  // Get next purchase order number
  getNextPurchaseOrderNumber: async () => {
    try {
      const response = await api.get('/purchase-order/number/next');
      return response.data;
    } catch (error) {
      console.error('Error fetching next purchase order number:', error);
      throw error;
    }
  },

  // Create purchase order
  createPurchaseOrder: async (orderData) => {
    try {
      const response = await api.post('/purchase-order', orderData);
      return response.data;
    } catch (error) {
      console.error('Error creating purchase order:', error);
      throw error;
    }
  },

  // Update purchase order
  updatePurchaseOrder: async (id, orderData) => {
    try {
      const response = await api.put(`/purchase-order/${id}`, orderData);
      return response.data;
    } catch (error) {
      console.error('Error updating purchase order:', error);
      throw error;
    }
  },

  // Delete purchase order
  deletePurchaseOrder: async (id) => {
    try {
      const response = await api.delete(`/purchase-order/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting purchase order:', error);
      throw error;
    }
  },

  // Send purchase order
  sendPurchaseOrder: async (id) => {
    try {
      const response = await api.put(`/purchase-order/${id}/send`);
      return response.data;
    } catch (error) {
      console.error('Error sending purchase order:', error);
      throw error;
    }
  },

  // Get purchase order statistics
  getPurchaseOrderStats: async () => {
    try {
      const response = await api.get('/purchase-order/stats');
      return response.data;
    } catch (error) {
      console.error('Error fetching purchase order statistics:', error);
      throw error;
    }
  }
};

export default purchaseOrderService;

